<template>
    <div class="left-panel">
        <div class="tasks-container mx-6">
            <v-text-field 
                v-if="current.tasks.length"
                :prepend-icon="'mdi-magnify'"
                single-line
                clear-icon="mdi-close-circle"
                clearable
                type="text"
                v-model="tasksSearch"
                class="mt-4"
            ></v-text-field>
        </div>
        <div class="add-task mt-2">
            <div class="flex-center pointer ml-4" v-if="tasks_plus" @click="hidePlusTasks">
                <img class="ml-2" height="33.91px" src="@/assets/images/components/button-add-blue.png">
                <div>
                    <div class="roboto-normal-18 clr-black-38 ml-6">Добавить подраздел</div>
                </div>
            </div>            
            <div v-else class="ml-6">
                <v-layout align-center>
                    <v-text-field class="add-task-field" @keypress.ctrl="addTaskHandle" v-model="tasks_plus_name" label=""  placeholder="Название подраздела" required></v-text-field>
                    <v-btn icon @click="addTaskHandle">OK</v-btn>
                </v-layout>
            </div>          
        </div>
        <SwitchActive @toggle="toggleAll" class="flex-center-between mx-4" :activeLength="tasksActiveLength" :allLength="current && current.tasks.length" :all="all" v-show="current.tasks.length"/>
        <div v-if="tasks && tasks.length" class="list-group-wrapper">
            <draggable 
                v-if="$vuetify.breakpoint.smAndUp"
                class="list-group"
                :list="current.tasks" 
                :animation="500"
                @change="getOrderTasks()"
                @start="dragging = true"
                @end="dragging = false"
            > 
                <div class="flex-center-between" v-for="(task, key) in tasks" :key="task._id">        
                    <Task
                        draggable="true"
                        @dragstart.native="startDragTask($event, task)"
                        @drop.native='dropSub($event, task._id)'
                        @dragover.prevent.native
                        @dragenter.prevent.native
                        :task="task"
                        @click.native="selectTask(task)" 
                        :groups="current.groups && task._id == headTask.find(el => el == task._id)"
                    />
                </div>
            </draggable> 
        </div>     
        <DeleteItem @deleteItem="deleteTheme()" :theme="true"/>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import draggable from 'vuedraggable'
import Task from './Task'
import DeleteItem from '../../popups/DeleteItem'
import SwitchActive from './SwitchActive.vue'

export default {
    name: 'LeftPanel',
    components:{
        Task,
        draggable,
        DeleteItem,
        SwitchActive,
    },
    data() {
        return {
            tasks_plus: true,
            tasks_plus_name: '',
            all: false,
            dragging: false,
            tasksSearch:'',
        }
    },
    computed:{
        ...mapGetters(["themes", "current" , "current_task", "picked_sub"]),
        tasks() {
            const tasks = this.current ? this.current.tasks : []
            const filterTasks = this.tasksSearch ? tasks.filter(el => el.name.toLowerCase().includes(this.tasksSearch.toLowerCase())) : tasks
            return this.all ? tasks && filterTasks : (tasks && filterTasks).filter(el => !el.completed && !this.current.groups.some(group => group.itemsId.some(id => id == el._id)) && !el.elder) 
        },
        tasksActiveLength() {
            return this.tasks && this.tasks.filter(el => !el.completed && !el.elder).length
        },
        headTask() {
            return this.tasks.filter(task => this.current.groups.some(group => group.headId == task._id)).map(el => el._id)
        },
    },
     methods:{
        ...mapActions(["addTask", "saveOrderTasks", "moveSub", "setRelavantNotices", "delTheme", "saveOrderThemes"]),
        ...mapMutations(["SET_CURRENT"]),
        hidePlusTasks(){
            this.tasks_plus = false
        },
        tasksRenameOk (){
            this.tasks_plus_name
            this.tasks_plus = true
            this.tasks_plus_name = ''
        },
        async addTaskHandle (){
            await this.addTask({theme_id: this.current._id, task:{name: this.tasks_plus_name,body: ""}})
            this.tasksRenameOk()
            const tasks_id = this.tasks.map(item => item._id)
            await this.saveOrderTasks({tasks_id, _id: this.current._id})
            if(this.$route.query.learn == 1) {
                const lastTheme = this.themes[this.themes.length - 1]
                const lastTask = lastTheme.tasks[lastTheme.tasks.length - 1]
                this.$router.push("/theme/" + lastTheme.route_name + "/" + lastTask.route_name + "?learn=2") 
            }
            this.tasks_plus = true
        },
        toggleAll (){
            this.all = !this.all
        },
        getOrderTasks () {
            const tasks_id = this.tasks.map(item => item._id)
            this.saveOrderTasks({tasks_id, _id: this.current._id})
        },
        startDragTask (evt, item) {
            evt.dataTransfer.dropEffect = 'move'
            evt.dataTransfer.effectAllowed = 'move'
            evt.dataTransfer.setData('dragTask', JSON.stringify(item))
        },
        async dropSub (evt, task_id) {
            if (evt.dataTransfer.getData('dragSub')) {
                const dropSub = JSON.parse(evt.dataTransfer.getData('dragSub'))
                this.moveSub({
                    theme_from_id: this.current._id,
                    task_from_id: this.current_task._id,
                    task_to_id: task_id,
                    sub_id: dropSub._id,
                })
            }
        },
        selectTask (task){
            this.setRelavantNotices(task)
            this.taskBody = task.body
            this.$router.push(`/theme/${this.current.route_name}/${task.route_name}`)
            task.subs[0] ? this.$emit('pickSub', task.subs[0]) : this.$emit('unpickSub')
            // this.pickedSub(this.picked_sub)
        },
        deleteTheme () {
            this.delTheme(this.current._id).then(() => {
                const themes_id = this.themes.map(item => item._id)
                this.saveOrderThemes(themes_id)
                this.$store.commit('SET_CURRENT', this.themes[0])
            })
        },
    },
    async mounted() {
        this.$root.$on('addTask', () => {
            this.tasks_plus = false
        })  
    },
}
</script>

<style lang="scss" scoped>
    .list-group-wrapper{
        overflow-y: auto;
    }
.left-panel {
    background: rgba(249, 249, 249, 1);
    width: 287px;
    height: calc(100vh - 94px);
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    .tasks-container {
        .theme--light.v-text-field>.v-input__control>.v-input__slot:before {
            border-color: rgba(0,0,0,.02);
        }
    }
    .add-task {
        .add-task-field {
            padding: 0 8px;
        }
    }
}
</style>